import React from 'react';
import DatePicker from 'react-datepicker';
import SingleSearch from '../../../components/ui/SingleSearch';
import { apiPhotoCountrySearch, apiPhotoCitiesSearch } from '../../../actions/photoActions';
import SingleSelect from '../../../components/ui/SingleSelect';
import moment from 'moment';

function PhotosFilters({
  filters = [],
  onChange,
  sort,
  onChangeSort,
  search = '',
  onChangeSearch,
}: any) {
  const checkFilter = (id: string, category: any) => {
    return (
      filters.find((filter: any) => filter.id === id && filter.value === category) !== undefined
    );
  };

  const deleteFilter = (id: string, value: string) => {
    onChange(
      filters.filter(
        (filter: any) => (filter.value !== value && filter.id === id) || filter.id !== id
      )
    );
  };

  const getDateFrom = () => {
    const dateFrom = filters.find((filter: any) => filter.id === 'Filming Date From');
    if (dateFrom !== undefined) {
      return moment(dateFrom.value).toDate();
    }
    return null;
  };

  const getDateTo = () => {
    const dateTo = filters.find((filter: any) => filter.id === 'Filming Date To');
    if (dateTo !== undefined) {
      return moment(dateTo.value).toDate();
    }
    return null;
  };

  const changeDateFrom = (date: Date) => {
    onChange([
      ...filters.filter((filter: any) => filter.id !== 'Filming Date From'),
      {
        id: 'Filming Date From',
        label: 'Filming Date From',
        value: moment(date).format('YYYY-MM-DD'),
      },
    ]);
  };

  const changeDateTo = (date: Date) => {
    onChange([
      ...filters.filter((filter: any) => filter.id !== 'Filming Date To'),
      {
        id: 'Filming Date To',
        label: 'Filming Date To',
        value: moment(date).format('YYYY-MM-DD'),
      },
    ]);
  };

  return (
    <div className="gallery-videos-left-inner">
      <div className="gallery-filter-area">
        <span className="gallery-filter-area-title">Search</span>
        <div className="gallery-filter-area-input">
          <input
            type="text"
            value={search}
            onChange={event => {
              onChangeSearch(event.target.value);
            }}
            className="custom-text-field-input"
            placeholder={'Search photo'}
          />
        </div>
      </div>
      <div className="gallery-filter-area">
        <span className="gallery-filter-area-title">Sort by</span>
        <div className="gallery-filter-area-input">
          <SingleSelect
            value={sort}
            onChange={(value: string) => {
              onChangeSort(value);
            }}
            elements={['Newest', 'Oldest']}
          />
        </div>
      </div>
      <div className="gallery-filter-area">
        <span className="gallery-filter-area-title">Filming date</span>
        <div className="gallery-filter-date-range">
          <div className="gallery-filter-date-range-input">
            <DatePicker selected={getDateFrom()} onChange={changeDateFrom} selectsStart />
          </div>
          <span className="gallery-filter-date-range-separator">-</span>
          <div className="gallery-filter-date-range-input">
            <DatePicker selected={getDateTo()} onChange={changeDateTo} selectsEnd />
          </div>
        </div>
      </div>
      <div className="gallery-filter-area">
        <span className="gallery-filter-area-title">Country</span>
        <div className="gallery-filter-area-input">
          <SingleSearch
            value={null}
            onChange={(value: any) => {
              if (!checkFilter(value, 'Country')) {
                onChange([
                  ...filters,
                  {
                    id: 'Country',
                    label: 'Country',
                    value: value,
                  },
                ]);
              }
            }}
            onSearch={apiPhotoCountrySearch}
            placeholder={'Please search country'}
          />
        </div>
        <div className="gallery-filter-tips">
          {filters
            .filter((filter: any) => filter.id === 'Country')
            .map((filter: any, index: number) => {
              return (
                <div
                  key={`country-${index}-${filter.value}`}
                  className="gallery-filter-tip-with-close"
                >
                  <span className="gallery-filter-tip-with-close-label">{filter.value}</span>
                  <span
                    className="span gallery-filter-tip-with-close-icon"
                    onClick={() => {
                      deleteFilter('Country', filter.value);
                    }}
                  >
                    x
                  </span>
                </div>
              );
            })}
        </div>
      </div>
      <div className="gallery-filter-area">
        <span className="gallery-filter-area-title">City</span>
        <div className="gallery-filter-area-input">
          <SingleSearch
            value={null}
            onChange={(value: any) => {
              if (!checkFilter(value, 'City')) {
                onChange([
                  ...filters,
                  {
                    id: 'City',
                    label: 'City',
                    value: value,
                  },
                ]);
              }
            }}
            onSearch={apiPhotoCitiesSearch}
            placeholder={'Please search city'}
          />
        </div>
        <div className="gallery-filter-tips">
          {filters
            .filter((filter: any) => filter.id === 'City')
            .map((filter: any, index: number) => {
              return (
                <div
                  key={`city-${index}-${filter.value}`}
                  className="gallery-filter-tip-with-close"
                >
                  <span className="gallery-filter-tip-with-close-label">{filter.value}</span>
                  <span
                    className="span gallery-filter-tip-with-close-icon"
                    onClick={() => {
                      deleteFilter('City', filter.value);
                    }}
                  >
                    x
                  </span>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}

export default PhotosFilters;
